import React from 'react'
import './style.scss'

function Title({title, description}) {

  return (
        <div className="cge-title">
            <div className="cge-title__title">
                <h2>{title}</h2>
            </div>
            {description && 
                <div className="cge-title__description">
                    <p>{description}</p>
                </div>}
        </div>
  )
}

export default Title